(function ($, Drupal) {

  'use strict'

  let a = document.querySelectorAll('.field--name-field-pdf span a');

  if (a.length!=0){
    a[0].setAttribute("download","");
    a[0].setAttribute("class", "btn btn-blue btn-size-small digest-btn mb-300");
    a[0].innerText = "Download";
  }

})(jQuery, Drupal);
